$(document).ready(function () {
  /* ---- INITIAL SETUP ---- */
  $("input[type='checkbox']").prop("disabled", false);

  $(window).on("beforeunload", function () {
    $(window).scrollTop(0);
  });

  /* ---- TAB CLICK ---- */
  $(".tab").click(function () {
    let tabId = $(this).attr("data-id");

    $(".tab-content").removeClass("active-tab-content");
    $(`.tab-content[data-id='${tabId}']`).addClass("active-tab-content");

    $(".tab").removeClass("active-tab");
    $(this).addClass("active-tab");

    $("#searchbar").val("").trigger("keyup");
    $("html, body").animate({ scrollTop: 0 }, 500);
  });

  /* ---- STICKY HEADER ---- */
  $(window).scroll(function () {
    let height = $(window).height();
    let scroll = $(window).scrollTop();
    $(".sticky-header").toggleClass("show", scroll > height);
  });

  /* ---- IMAGE UPDATE (FIXED) ----- */
  function imageUpdate() {
    let $slots = $("#tab_images li");
    $slots.find("img")
      .attr("src", "")
      .removeAttr("data-product-id data-tab-id");

    let index = 0;

    $("#flexi-box-form .product-checkbox:checked").each(function () {
      let imgUrl = $(this).data("img");
      let productId = $(this).data("product-id");
      let tabId = $(this).data("id-products").split("_")[1];
      let qty = parseInt($(this).closest(".product-info").find(".quantity-input").val()) || 1;

      for (let i = 0; i < qty; i++) {
        if (index < $slots.length) {
          $slots.eq(index).find("img")
            .attr("src", imgUrl)
            .attr("data-product-id", productId)
            .attr("data-tab-id", tabId);
          index++;
        }
      }
    });
  }

  function listAdd() {
      let totalPrice = 0;
      let update_price = 0;
      
      $("#bundle_submit input[name^='properties[sub_item_']").remove();
      $("#bundle_submit input[name='properties[uniware_items]']").remove();

      $("#flexi-box-form")
         .find(".product-checkbox:checked")
         .each(function () {
            let quantity =
               parseInt($(this).closest(".product-info").find(".quantity-input").val()) || 1;
            let bundleParts = $(this).attr("data-bundle").split("/");
            totalPrice += parseFloat(bundleParts[1]) * quantity;
         });

      let items = 0;
      let productData = { properties: { uniware_items: { items: [] } } };

      let $parentbox = $("#parentSKU");

      $("#flexi-box-form")
         .find(".product-checkbox:checked")
         .each(function () {
            let $checkbox = $(this);
            let productValue = $checkbox.val();
            let productName = $checkbox.attr("name") || "";

            if (
               !productValue ||
               productValue.toLowerCase() === "no" ||
               productValue.toLowerCase().includes("hidden") ||
               productName.toLowerCase().includes("hidden")
            ) {
               $checkbox.prop("disabled", true);
               return;
            }

            let bundle = $checkbox.attr("data-bundle") || "";
            let quantity =
               parseInt($checkbox.closest(".product-info").find(".quantity-input").val()) || 1;

            let originalValue =
               $checkbox.attr("data-original-value") ||
               productValue.split(" (Qty:")[0];
            $checkbox.attr("data-original-value", originalValue);

            let productProperty = originalValue;
            if (quantity > 1) productProperty += ` (Qty: ${quantity})`;

            $checkbox.attr("name", "properties[Item " + items + "]");
            $checkbox.val(productProperty);

            let bundleParts = bundle.split("/");
            update_price =
               (parseFloat(bundleParts[1]) * quantity / totalPrice) *
               $checkbox.data("bundle-price");
            let sub_sku = $checkbox.data("sku") || "";
            let sub_img = $checkbox.data("img_name") || "";
            
            let itemObj = {
               id: $checkbox.data("variant-id") || "",
               quantity: quantity
            };
            let item_index = items + 1;
            let subItemLabel = `sub_item_${item_index}`;
            let subItemValue = `${originalValue} x ${quantity} :: ${sub_img}`;
            $("<input>")
               .attr("type", "hidden")
               .attr("name", `properties[${subItemLabel}]`)
               .val(subItemValue)
               .appendTo("#bundle_submit");
            productData.properties.uniware_items.items.push(itemObj);
            items++;
         });

      // Convert to JSON string
      productData.properties.uniware_items = JSON.stringify(
         productData.properties.uniware_items
      );

      // Add main uniware JSON
      $("<input>")
         .attr("type", "hidden")
         .attr("name", "properties[uniware_items]")
         .val(productData.properties.uniware_items)
         .appendTo("#bundle_submit");
  }
  let checkboxes = $("input[type='checkbox']");

  /* ---- QUANTITY HELPERS ---- */
  function updateQuantity(input, change) {
    let current = parseInt(input.val()) || 1;
    let min = parseInt(input.attr("min")) || 1;
    let max = parseInt(input.attr("max")) || 999;

    let next = current + change;
    if (next >= min && next <= max) {
      input.val(next);
      input.closest(".product-info").find(".product_counter").text(next);
    }
  }

  function getTotalSelectedQuantityInTab(tabId) {
    let total = 0;
    $(`.tab-content[data-id="tab${tabId}"] .product-checkbox:checked`).each(function () {
      let qty = parseInt($(this).closest(".product-info").find(".quantity-input").val()) || 1;
      total += qty;
    });
    return total;
  }

  /* ---- TAB COUNT UPDATE ---- */
  function updateTabCounts(tabId) {
    let $tabContent = $(`.tab-content[data-id="tab${tabId}"]`);
    let limit = parseInt($tabContent.data("product-limit"));
    let total = getTotalSelectedQuantityInTab(tabId);

    imageUpdate();

    let counterId = `#checkbox_count_tab_${tabId}_product`;

    if (total === limit) {
      $(counterId).show().html("&#10004;");
      $tabContent.find(".product-checkbox:not(:checked)").prop("disabled", true)
        .closest(".add-to-box").addClass("disables");
    } else if (total > 0) {
      $(counterId).show().text(total);
      $tabContent.find(".product-checkbox").prop("disabled", false)
        .closest(".add-to-box").removeClass("disables");
    } else {
      $(counterId).hide();
      $tabContent.find(".product-checkbox").prop("disabled", false)
        .closest(".add-to-box").removeClass("disables");
    }
    
    let remaining = Number(limit) - Number(total);
    if (remaining == limit) {
      $("#freegift-bar p").text(`Choose any ${limit} perfumes`);
    } else if (remaining != 0) {
      $("#freegift-bar p").text(`Choose ${remaining} more perfumes`);
    } else {
      $("#freegift-bar p").text("🎉 Perfect choice! CHECKOUT now.");
    }

    checkSubmitButtonVisibility();

    if (total === limit) {
      let nextTab = `tab${parseInt(tabId) + 1}`;
      if ($(`.tab[data-id="${nextTab}"]`).length) {
        setTimeout(() => $(`.tab[data-id="${nextTab}"]`).click(), 400);
      }
    }
  }

  /* --- SUBMIT BUTTON ENABLE ---- */
  function checkSubmitButtonVisibility() {
    let total = 0;
    $(".tab-content").each(function () {
      let tabId = $(this).data("id").replace("tab", "");
      total += getTotalSelectedQuantityInTab(tabId);
    });

    const isEnabled = total === totalproductSelection;
    $("#submitBundleBox").prop("disabled", !isEnabled);
    if (isEnabled) { listAdd(); }
  }

  function submitAddForm(items) {
      fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items })
      })
      .then(response => response.json())
      .then(data => {
          fetch('/?sections=cart-drawer,cart-icon-bubble')
          .then(res => res.json())
          .then(sections => {
            let cartHtml = sections['cart-drawer'];
            let tempDiv = document.createElement('div');
            tempDiv.innerHTML = cartHtml;
            let drawerInner = tempDiv.querySelector('.drawer__inner');
            document.querySelector('cart-drawer .drawer__inner').innerHTML = drawerInner.innerHTML;
            const drawer = document.querySelector('cart-drawer');
            if (drawer?.classList.contains('is-empty')) { drawer.classList.remove('is-empty'); }

            console.log(drawerInner.innerHTML);
            const bubble = document.querySelector('#cart-icon-bubble');
            if (bubble) { bubble.innerHTML = sections['cart-icon-bubble']; }
            const cartIcon = document.querySelector('#cart-icon-bubble a, #cart-icon-bubble');
            if (cartIcon) { cartIcon.click(); }
          });
      })
      .catch(err => console.error("Error:", err));
  }

  /* ---- QUANTITY BUTTONS ---- */
  $(document).on("click", ".quantity-plus", function (e) {
    e.preventDefault();
    let input = $(this).siblings(".quantity-input");
    let tabId = parseInt(input.data("tab-index"));

    updateQuantity(input, 1);
    updateTabCounts(tabId);
  });

  $(document).on("click", ".quantity-minus", function (e) {
    e.preventDefault();
    let input = $(this).siblings(".quantity-input");
    let tabId = parseInt(input.data("tab-index"));

    updateQuantity(input, -1);
    updateTabCounts(tabId);
  });

  /* ---- CHECKBOX CLICK ----- */
  $(document).on("click", ".product-checkbox", function () {
    let tabId = Number($(this).data("id-products").split("_")[1]);
    let $product = $(this).closest(".product-info");

    if ($(this).is(":checked")) {
      $product.find(".quantity-selector").show();
      $product.find(".added_to_cart, .product_counter").removeClass("_hidden");
      $product.find(".quantity-input").val(1);
      $product.find(".product_counter").text(1);
    } else {
      $product.find(".quantity-selector").hide();
      $product.find(".added_to_cart, .product_counter").addClass("_hidden");
      $product.find(".quantity-input").val(1);
    }

    updateTabCounts(tabId);
  });

  /* ----- IMAGE REMOVE (FIXED) ---- */
  $("#tab_images").on("click", ".remove-img", function (e) {
      e.preventDefault();
      e.stopPropagation();

      let $img = $(this).siblings("img");
      let productId = $img.data("product-id");
      let tabId = parseInt($img.data("tab-id"));

      if (!productId || !tabId) return;

      let $checkbox = $(`.product-checkbox[data-product-id="${productId}"]`);
      if (!$checkbox.length) return;

      let $product = $checkbox.closest(".product-info");
      let $qtyInput = $product.find(".quantity-input");
      let qty = parseInt($qtyInput.val()) || 1;

      if (qty > 1) {
         qty--;
         $qtyInput.val(qty);
         $product.find(".product_counter").text(qty);
      } else {
         $checkbox.prop("checked", false);
         $qtyInput.val(1);
         $product.find(".quantity-selector").hide();
         $product.find(".added_to_cart, .product_counter").addClass("_hidden");
      }

      // ✅ Update tab state
      updateTabCounts(tabId);

      // ✅ SWITCH TO THE TAB FROM WHICH ITEM WAS REMOVED
      let $targetTab = $(`.tab[data-id="tab${tabId}"]`);
      if ($targetTab.length) {
         $(".tab").removeClass("active-tab");
         $(".tab-content").removeClass("active-tab-content");

         $targetTab.addClass("active-tab");
         $(`.tab-content[data-id="tab${tabId}"]`).addClass("active-tab-content");

         $("html, body").animate({ scrollTop: 0 }, 400);
      }
  });

  /* ---- SEARCH ----- */
  $("#searchbar").on("keyup", function () {
    let value = $(this).val().toLowerCase();
    $("#collection-list li").each(function () {
      $(this).toggle($(this).text().toLowerCase().includes(value));
    });
  });

  $(".search-clear").click(function () {
    $("#searchbar").val("").trigger("keyup");
  });

  $(document).on("click", "#submitBundleBox", function (e) {
       e.preventDefault();

       let productItems = [];
       
       let variant = $("#bundle_submit input[name='id']").val() || "";
       let props = {
          custom_flag: "flexibox",
          byob: true
       };

       $("#bundle_submit input[name^='properties[sub_item_']").each(function () {
          let name = $(this).attr("name").replace("properties[", "").replace("]", "");
          props[name] = $(this).val();
       });
       props["uniware_items"] = $("#bundle_submit input[name='properties[uniware_items]']").val() || "";
       let data_new = $("#bundle_submit input[name='properties[uniware_items]']").val();
       let parsedData = JSON.parse(data_new);

// console.log(parsedData.items);
parsedData.items.forEach(item => {
        productItems.push({
            id: item.id,
            quantity: item.quantity,
            properties: {
                _bundle: "true"
            }
        });
    }); /*
    if (e.target.dataset.formtype) {
      productItems.push({
          id: 48333235617962,
          quantity: 2,
          properties: {
            _reward: "true"
          }
       });
    } */
       // return; 
       /*
       productItems.push({
          id: variant,
          quantity: 1,
          properties: props
       }); */
       console.log(productItems);

       if (productItems.length) {
         (e.target.dataset.formtype) ? onBuyNowClick(e, false, productItems) : submitAddForm(productItems);
       }
  });

});